class NavigationTabs extends window.BAO.CustomElement() {
  setupListeners () {
    this.tabs = this.els.tab?.elements
    this.panels = this.els.panel?.elements

    if (!this.tabs) return

    this.tabs.forEach(tab => {
      this.listeners.add(tab, 'click', this.handleTabClick.bind(this))
    })
  }

  handleTabClick (e) {
    const tab = e.target.closest(this.els.tab.selector)
    const id = tab.dataset.tabId
    const titleHandle = tab.dataset.titleHandle

    if (!id) return

    if (this.externalEls?.container?.element) {
      this.externalEls.container.element.scrollTo({
        top: 0,
        behavior: 'smooth',
      })

      this.externalEls.container.element.dataset.activeTabTitle = titleHandle
    }

    this.updateTabs(id)
    this.updatePanels(id)
  }

  updateTabs (id) {
    this.tabs.forEach(tab => {
      tab.setAttribute('aria-pressed', tab.dataset.tabId === id)
    })
  }

  updatePanels (id) {
    this.panels.forEach(panel => {
      panel.setAttribute('aria-hidden', panel.dataset.panelId !== id)
    })
  }
}

if (!customElements.get('navigation-tabs')) {
  customElements.define('navigation-tabs', NavigationTabs)
}
